export const calculateScoreAndIndexes = (AnswerNames, OptionNames, userOrder) => {
  if (!AnswerNames || userOrder.length === 0)
    return { userIndexes: [], correctIndexes: [], score: 0 };

  const correctOrderIndexes = AnswerNames.map(
    (answer) => OptionNames.indexOf(answer)
  );

  let score = 0;

  const correctPairs = new Set(
    correctOrderIndexes.slice(0, correctOrderIndexes.length - 1).map((_, i) => 
      `${correctOrderIndexes[i]}-${correctOrderIndexes[i + 1]}`
    )
  );

  for (let i = 0; i < userOrder.length - 1; i++) {
    const userPair = `${userOrder[i]}-${userOrder[i + 1]}`;
    if (correctPairs.has(userPair)) {
      score += 1;
    }
  }

  return {
    userIndexes: userOrder,
    correctIndexes: correctOrderIndexes,
    score,
  };
};

export const getScore = (questions, answers, option = 1) => {
  if (option === 1) {
    let score = 0;
    for (let i = 0; i < questions.length; i++) {
      if (questions[i] !== undefined && answers[i] !== undefined) {
        if (
          typeof questions[i] === "string" &&
          typeof answers[i] === "string" &&
          questions[i].toLowerCase() === answers[i].toLowerCase()
        ) {
          score++;
        } else if (questions[i] === answers[i]) {
          score++;
        }
      }
    }
    return score;
  } else if (option === 2) {
    let score = 0;
    questions.forEach((correctAnswer) => {
      const isCorrect = answers.includes(correctAnswer);
      if (isCorrect) {
        score += 1;
      }
    });
    answers.forEach((answer) => {
      const isCorrect = questions.includes(answer);
      if (!isCorrect) {
        score = Math.max(0, score - 1);
      }
    });
    return score;
  }
};
